import React, { useContext } from 'react';
import { ConfigContext } from '../../../../../Contexts/ConfigContext';
import InputConfig from '../../../../../Components/InputConfig';
import ErrorBoundary from '../../../../../Components/CustomErrorBoundary/CustomErrorBoundary';
import PageHeading from '../../../../../Components/PageHeading';
//mui imports====
import useCommonStyles from '../../../../../commonStyles';
import Typography from '@mui/material/Typography';
import { Grid, Paper } from '@mui/material';
import ModeCustomLabelConfig from './ModeCustomLabelConfig';
import UpdateReactJson from '../../../../../Components/UpdateReactJson';
//===============

const CustomLabelConfig = ({ keyData , featureDescription}) => {
	const commonStyleClasses = useCommonStyles();
	const { rawConfig, updateRawConfig } = useContext(ConfigContext); //rawConfig from ConfigContext

	return (
		<Paper
			style={{ paddingBottom: '6rem' }}
			className={commonStyleClasses.mainPagePaperMarginStyle}
		>
			<PageHeading
				headingName="Custom Label"
				headingPath={['Dashboard', 'Framerate', 'Features Data', 'Custom Label']}
				description="Manage Custom Label Configurations"
				showInfoButton = {true}
				infoMessage={featureDescription}
			/>
			<Grid container spacing={2} style={{ width: '95%', margin: '3rem auto 1rem auto' }}>
				<Grid item xs={3}>
					<InputConfig
						label="Text"
						keyData={keyData + '.text'}
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
					/>
				</Grid>
				<Grid item xs={4.5}>
					<InputConfig
						label="Image URL"
						keyData={keyData + '.img'}
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
					/>
				</Grid>
				<Grid item xs={4.5}>
					<InputConfig
						label="Redirect URL"
						keyData={keyData + '.redirectUrl'}
						object={rawConfig}
						updateObject={updateRawConfig}
						inputStyles={{ width: '100%', marginTop: '1rem' }}
						labelStyles={{ width: '100%' }}
					/>
				</Grid>
				<Grid item xs={12} style={{ margin: '2rem 0 2rem 0' }}>
					<Typography fontWeight={300} variant="h4">
						Textstyles
					</Typography>
				</Grid>
				<Grid
					item
					xs={12}
					style={{
						border: '1px solid darkgrey',
						borderRadius: '4px',
						marginLeft: '1.5rem',
						marginBottom: '4rem'
					}}
				>
					<ErrorBoundary>
						<UpdateReactJson
							keyData={keyData + '.textStyles'}
							object={rawConfig}
							updateObject={updateRawConfig}
						/>
					</ErrorBoundary>
				</Grid>
				<Grid item xs={6}>
					<ModeCustomLabelConfig keyData={keyData + '.inContentMode'} title={'In Content Mode'} />
				</Grid>
				<Grid item xs={6}>
					<ModeCustomLabelConfig keyData={keyData + '.floatingMode'} title={'Floating Mode'} />
				</Grid>
			</Grid>
		</Paper>
	);
};
export default CustomLabelConfig;
